<template>
    <v-container class="contact">
        <v-row class="px-5">
            <v-col cols="12" lg="6">
                <v-row class="contact-text pt-5">
                    <v-col md="12" sm="12" xs="12" lg="12">
                        <span class="my-2 title" >{{language=='Ελληνικά'? 'Επικοινωνία' : 'Contact us'}}</span>
                    </v-col>
                </v-row>
                <v-row class="my-0">
                    <v-col class="text" md="12" sm="12" xs="12" lg="12">
                        <span class="material-icons">
                            location_on
                        </span>
                        <span>
                            <a :href="url">
                                {{language=='Ελληνικά'? this.contact.address : 'Leoforos Amfitheas 167 & Metsovou 2, P.Faliro, 175 63'}}
                            </a>
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text" md="12" sm="12" xs="12" lg="12">
                        <span class="material-icons">
                            email
                        </span>
                        <span>
                            {{this.contact.mail}}
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text" md="12" sm="12" xs="12" lg="12">
                        <span class="material-icons">
                            call
                        </span>
                        <span>
                            {{this.contact.phone}}
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text" md="12" sm="12" xs="12" lg="12">
                        <span class="material-icons">
                            call
                        </span>
                        <span>
                            {{this.contact.mobile}}
                        </span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" lg="6">
                <v-row class="contact-text pt-5">
                    <v-col md="12" sm="12" xs="12" lg="12">
                        <span class="my-2 title" >{{language=='Ελληνικά'? 'Ευκαιρίες Καριέρας' : 'Career opportunities'}}</span>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col class="text" md="12" sm="12" xs="12" lg="12">
                        <span v-if="language=='Ελληνικά'">Η τεχνική - κατασκευαστική εταιρεία AGGELOPOULOS - SARANTIS αναζητά πάντα έμπειρο και δυναμικό προσωπικό. Στείλτε μας το βιογραφικό σας, στο {{this.contact.mail}} </span>
                        <span v-else>The technical - construction company AGGELOPOULOS - SARANTIS is always looking for potential experienced and dynamic associates. Send us your cv at {{this.contact.mail}} </span>  
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="12" sm="12" xs="12" lg="12">
                        <span>
                            <a href="https://www.facebook.com/ASKtirio" target="_blank">
                                <v-icon large color="black">mdi-facebook</v-icon>
                            </a>
                        </span>
                        <span class="mx-2">
                            <a href="https://www.instagram.com/as_aggelopoulos_sarantis/" target="_blank">
                                <v-icon large color="black">mdi-instagram</v-icon>
                            </a>
                        </span>
                        <span>
                            <a href="https://www.youtube.com/@aggelopoulossarantis" target="_blank">
                                <v-icon x-large color="black">mdi-youtube</v-icon>
                            </a>
                        </span>
                        <span class="ml-1">
                            <a href="https://www.tiktok.com/@asktirio" target="_blank">
                                <img height="30px" :src="require('@/assets/tiktok.svg')"/>
                            </a>
                        </span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
            <gmap-map
            :center="center"
            :zoom="17"
            :options="options"
            style="width:100%;  height: 50vh;"
            >
                <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    @click="center=m.position"
                ></gmap-marker>
            </gmap-map>
        </v-row>
     </v-container>
</template>   

<script>
import restApi from "@/rest-api";

export default {
    props: {
        language: String
    },
    data() {
        return {
            center: { lat: 37.924458, lng: 23.705159 },
            markers: [
                {
                    position: {lat: 37.924458, lng: 23.705159 }
                }
            ],
            options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: true,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUI: false
            },
            contact: {},
            url: ""
        }
    },
    created() {
      this.fetchContactDetails();
    },
    methods: {
        fetchContactDetails() {
            var search = `/contact`;
            restApi
            .get(search)
            .then(response => {
                 this.contact = response.data[0]
                 this.url = `https://www.google.gr/maps/search/${this.contact.address}+/@+${this.contact.coordinates}?hl=en`
            })
            .catch((error) => {
                console.log(error);
            });
      },
    }
}
</script>

<style lang="scss" scoped>

    @media only screen and (min-width: 600px){
        .contact{
            margin-top: 5%;
            height: auto;
            margin-bottom: 5%;
        }
    }

    @media only screen and (max-width: 600px){
        .contact{
            margin-top: 10%;
            height: auto;
            margin-bottom: 20%;
        }
    }

    .contact-text {
        .title{
            font-size: 20px!important;
        }
        .text{
            font-size: 15px!important;
            padding: 4px;
        }
    }
    a {
        color: black !important; /* blue colors for links too */
        text-decoration: none; /* no underline */
    }
    span {
     vertical-align: middle;
    }
</style>